import { createContext, type FC, type ReactElement, useState } from 'react';
import type { Order, RemoteCoolerModel, RemoteSortingFields } from '../models';

interface IRemotesContext {
  remotesUpdate: boolean;
  toggleRemoteCoolersUpdate: () => void;
  remotes: RemoteCoolerModel[];
  setRemotes: (val: RemoteCoolerModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: RemoteSortingFields;
  setOrderBy: (val: RemoteSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const RemoteCoolersContext = createContext<IRemotesContext>({} as IRemotesContext);

export const RemotesProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [remotesUpdate, setRemotesUpdate] = useState(false);
  const [remotes, setRemotes] = useState<RemoteCoolerModel[]>([]);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [count, setCount] = useState<number>(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<RemoteSortingFields>('name');
  const [loading, setLoading] = useState(false);
  const toggleUpdate = (): void => setRemotesUpdate(!remotesUpdate);

  return (
    <RemoteCoolersContext.Provider
      value={{
        remotesUpdate,
        toggleRemoteCoolersUpdate: toggleUpdate,
        remotes,
        setRemotes,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        loading,
        setLoading
      }}
    >
      {children}
    </RemoteCoolersContext.Provider>
  );
};
